const serverApi = window.serverApi;
const isDevelopment = window.isDevelopment;
const isStaging = window.isStaging;
const isSmokescreen = window.isSmokescreen;
const isProduction = window.isProduction;
const isElectron = window.isElectron;
// Combo of a commit hash and the build number.
const buildVersion = window.buildVersion || "dev";
// Circle ci build number in sequential order.
const buildNumber =
    buildVersion !== "dev"
        ? parseInt(window.buildVersion.split("-")[1])
        : Number.POSITIVE_INFINITY;

const serverContext = window.serverContext || {};
const electronAppVersion = window.electronAppVersion || null;

function getStaticUrl(path, isAbsolute) {
    if (window.staticUrl) {
        if (window.manifest[path]) {
            if (isAbsolute && window.manifest[path].startsWith("http")) {
                return window.manifest[path];
            } else {
                return window.staticUrl + window.manifest[path];
            }
        }
        return window.staticUrl + path;
    } else {
        return path;
    }
}

export {
    serverApi,
    serverContext,
    isDevelopment,
    isStaging,
    isSmokescreen,
    isProduction,
    isElectron,
    electronAppVersion,
    buildVersion,
    buildNumber,
    getStaticUrl,
};
